export default __webpack_public_path__ + "img/Montserrat-Bold_180ba33.woff";